
export const cashConfig = `<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （1）解压打螺丝活动时间为 2024 年9 月 01 日至 2025 年9月 01 日；活动范围为所有进入本游戏的用户；本次活动名额仅限前 100000 名用户。本游戏预计提现最高金额为 10000 元。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （2）请您理解并同意产品内分红及现金发放数量随机。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （3）解压打螺丝展示多个提现比例，使用每个提现比例有自己的使用要求，用户达到后方可按对应提现比例进行提现。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （4）单个用户总提现次数不限，单日最高可提 10 次。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    您可满足对应提现比例要求后进行提现，具体规则如下：
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （5）【现金提现】提现规则
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    a、提现0.1元：如您想在解压打螺丝【现金提现】账户提现0.1元，需要同时满足以下几个条件即可成功提现 1 次：1）通过第 2 关且计算账号价值（根据通关数、游戏市场、观看广告次数、是否是幸运用户计算）余额大于0.1元即可提现。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    b、提现0.2元：如您想在解压打螺丝【现金提现】账户提现0.2元，需要同时满足以下几个条件即可成功提现 1 次：1）通过第 5 关且计算账号价值（根据通关数、游戏市场、观看广告次数、是否是幸运用户计算）余额大于0.2元即可提现。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    c、提现30元：如您想在解压打螺丝【现金提现】账户提现30元，需要同时满足以下几个条件即可成功提现 1 次：1）通过第 10关且计算账号价值（根据通关数、游戏市场、观看广告次数、是否是幸运用户计算）余额大于30元且领取到系统加赠的200元。2）在第10关的基础上再过2关完成激活；3）激活成功后发起审核并且领取到系统加赠的100元，7日后完成审核，打卡7日，每天通过2关即会审核成功；4）审核成功后观看380个视频，活跃等级达到 28级即可到账微信，每天 1个提现名额。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    d、提现100元：如您想在解压打螺丝【现金提现】账户提现100元，需要同时满足以下几个条件即可成功提现 1 次：1）通过第 15关且计算账号价值（根据通关数、游戏市场、观看广告次数、是否是幸运用户计算）余额大于100元且提现机会未用完即可提现。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    e、提现全部：如您想在解压打螺丝【现金提现】账户提现全部累计金额，需要同时满足以下几个条件即可成功提现 1 次：1）通过第20关且计算账号价值（根据通关数、游戏市场、观看广告次数、是否是幸运用户计算）；2）打卡30日或活跃等级达到29级；3）每天 1个提现名额。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    e、提现全部：如您想在解压打螺丝【现金提现】账户提现全部累计金额，需要同时满足以下几个条件即可成功提现 1 次：1）通过第25关且计算账号价值（根据通关数、游戏市场、观看广告次数、是否是幸运用户计算）提现机会未用完即可提现。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    e、提现全部：如您想在解压打螺丝【现金提现】账户提现全部累计金额，需要同时满足以下几个条件即可成功提现 1 次：1）通过第30关且计算账号价值（根据通关数、游戏市场、观看广告次数、是否是幸运用户计算）；2）在第30关的基础上再过36关；3）活跃等级达到 30级；4）每天 1个提现名额。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    e、提现全部：如您想在解压打螺丝【现金提现】账户提现全部累计金额，需要同时满足以下几个条件即可成功提现 1 次：1）通过第35关且计算账号价值（根据通关数、游戏市场、观看广告次数、是否是幸运用户计算）；2）在第35关的基础上再过131关；3）活跃等级达到 30级；4）每天 1个提现名额。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （6）【红包提现】提现规则
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    a、10000 元游戏红包=1 元人民币，用户通过玩游戏、观看视频获得游戏现金，用户可提现金额=所选提现汇率*当前现金账户余额，可提现金额达到 0.1 元方可进行提现，最大提现额度限制为 1000 元，每天 10 次提现机会，无时间限制或注册时长限制。当用户累计提现的金额+当前提现的余额<累计看广告为平台产生的收益即可提现，当不满足时，会提示用户继续游戏，并在达到下一目标后再次判定。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    b、10000 元红包=1 元人民币：需要满足以下几个条件即可成功提现：1）通过第 1 关。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    c、10000 元红包=1.2 元人民币：需要满足以下几个条件即可成功提现：1）通过第8 关。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    e、10000 元红包=1.5 元人民币：需要满足以下几个条件即可成功提现：1）通过第 13关。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    f、10000 元红包=1.8 元人民币：需要满足以下几个条件即可成功提现：1）通过第16关。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    g、10000 元红包=2 元人民币：需要满足以下几个条件即可成功提现：1）通过第 22关。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    h、10000 元红包=2000 元人民币：需要满足以下几个条件即可成功提现：1）通过第 28关；2）获得的累计徽章数达35个；3）集齐4套生肖牌。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    i、10000 元红包=10000 元人民币：需要满足以下几个条件即可成功提现：1）通过第 36 关；2）获得的累计徽章数达50个；3）集齐5套生肖牌。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （7）【生肖兑换】提现规则
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    收集全套生肖牌即可兑换黄金
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    a、兑换黄金一生相伴15g：如您想在解压打螺丝【生肖兑换】账户兑换黄金一生相伴15g：满足以下几个条件即可成功兑换1）集齐全套生肖牌。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    b、兑换黄金一生相随15g：如您想在解压打螺丝【生肖兑换】账户兑换黄金一生相随15g：满足以下几个条件即可成功兑换1）集齐全套生肖牌。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    c、成功兑换相伴相随后还需再集齐1套生肖牌激活发货，活跃等级满30即后即可发货，每天限量发发1人。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （8）【暑期福利金】提现规则
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    幸运用户随机抽取福利金金额，最高88000元 ：完成3日任务即可领取，需要满足以下几个条件即可成功提现：1）完成3日审核任务；2）累计登录30天成为活跃用户，活跃等级达30级。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （9）【徽章兑换】提现规则
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    a 新手福利0.1元（限1次）：收集2枚徽章即可兑换
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    b 新手福利80元（限1次）：（1）打卡10天 ；2）活跃等级30级，5）每天 1 个提现名额。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    C 福利0.1元（无限次兑换）：收集5枚徽章即可兑换
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    D 福利80元（无限次兑换）：收集30枚徽章即可兑换，需要满足以下几个条件即可成功提现：1）累计金额达100元，2）活跃等级30级，3）每天 1 个提现名额。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （10）【2024福利金】提现规则
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    福利金8800元最高翻10倍 ：完成3日任务即可领取，需要满足以下几个条件即可成功提现：1）累计通关188关，2）活跃等级30级，3）每天 1 个提现名额。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （11）【好友提现】提现规则： 部分提现需要认证账号无风险，若有风险需要邀请好友验证辅助提现。邀请第一个新用户最高可得5元奖励，第二个最高可得10元奖励，第三个最高可得15元奖励。被邀请用户成功提现并完成3个订单即可成为有效好友。邀请好友提现收益由被邀请有效好友的红包收益决定，被邀请有效好友每次观看广告获得的红包会以10%的比例额外奖励给邀请方。邀请好友收益满0.3元即可提现，每天上限提现10次，无其他提现要求。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （12）产品内活跃等级共有 30 级，观看一定次数的视频广告即可升级，无其他要求，等级与对应的观看次数对应关系如下（前为观看次数，后为对应等级数，等级间以逗号分割）： "0":1 级，"2":2 级，"3":3 级，"4":4 级，"5":5 级，"6":6 级，"7":7 级，"8":8 级，"9":9 级，"10":10 级，"15":11 级，"20":12 级，"25":13 级，"30":14 级，"40":15 级，"50":16 级，"60":17 级，"70":18 级，"80":19 级，"100":20 级，"120":21 级，"140":22 级，"160":23 级，"180":24 级，"200":25 级，"300":26 级，"500":27 级，"800":28 级，"1000":29 级，"300000":30 级 。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （13）由于微信支付需要实名制，非实名用户账号无法支持提现，请务必将提现的微信号进行实名认证，因未实名导致的提现失败不进行退款；
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （14）单笔提现金额最低 0.1 元，最高金额为 10000 元。每日最多 10 次提现，除下述提及的档位提现要求以外，无注册时长条件，无在线时长条件，无提现间隔条件，无等级条件要求，无邀请好友，总体提现次数不限。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （15）上述“任务”类型或者“档位”类型的提现项，最大单笔金额为最高任务或者最大档位对应显示的金额，每个任务或者档位达到提示的要求即可提现，无其他要求，不同用户花费的时长也不一样。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （16）不同用户的广告收益不同，广告结束后会根据用户的广告价值计算和发放，不同用户达到对应档位的余额，时间也不一致。
    </span>
</p>
<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
    <span style="font-family:宋体; font-size:10.5pt">
    （17）解压打螺丝保留对本产品的最终解释权，若发现用户有外挂等恶意作弊行为，一律封禁账号并扣除账户所有余额。
    </span>
</p>`;
